import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import user from './modules/user';
import error from './modules/error';
import permission from './modules/permission';
import dictionary from './modules/dictionary';
import getters from './getters';

// Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        app,
        user,
        error,
        permission,
        dictionary
    },
    getters
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js